import { render, staticRenderFns } from "./cityForm.vue?vue&type=template&id=35a5d162"
import script from "./cityForm.vue?vue&type=script&lang=js"
export * from "./cityForm.vue?vue&type=script&lang=js"
import style0 from "./cityForm.vue?vue&type=style&index=0&id=35a5d162&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports